import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdbModalModule, MdbModalService } from 'src/lib/mdb5-adapted/public-api';
import { ApiloaderWidgetComponent } from '../apiloader/apiloaderwidget.component';
import { ApiloaderService } from '../apiloader/apiloader.service';

import { SpinnerComponent } from './spinner.component';
import { LoadSpinnerService } from './loadspinner.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MdbModalModule,
    SpinnerComponent,
    ApiloaderWidgetComponent
  ],
  providers:[MdbModalService, LoadSpinnerService, ApiloaderService],
  exports: [SpinnerComponent, ApiloaderWidgetComponent]
})
export class LoadingSpinModule { }
